import { useEffect } from "react";

const useTopFiltersEffect = ({
                                 topFilters,
                                 metaDataDate,
                                 setFilters,
                                 setSelectedFieldName,
                                 setSelectedFieldValue,
                                 reset,
                             }) => {
    useEffect(() => {
        if (reset) {
            const fieldNames = topFilters.map((filter) => filter.name);
            const allValues = [];

            topFilters.forEach((filter) => {
                if (filter.values) {
                    allValues.push(...filter.values);
                } else if (
                    filter.minimum !== undefined &&
                    filter.maximum !== undefined
                ) {
                    const isDateType = metaDataDate.some(
                        (metadata) => metadata.name === filter.name,
                    );
                    if (!isDateType) {
                        allValues.push(filter.minimum.toFixed(1));
                        allValues.push(filter.maximum.toFixed(1));
                    }
                }
            });

            setSelectedFieldName([...new Set(fieldNames)]);
            setSelectedFieldValue([...new Set(allValues)]);
            setFilters([...topFilters]);
        } else {
            // Default behavior when not resetting
            const fieldNames = topFilters.map((filter) => filter.name);

            setSelectedFieldName((prevFieldNames) => {
                const preparedFieldNames = Array.isArray(prevFieldNames)
                    ? prevFieldNames
                    : [];
                return [...new Set([...preparedFieldNames, ...fieldNames])];
            });

            const allValues = [];

            topFilters.forEach((filter) => {
                if (filter.values) {
                    allValues.push(...filter.values);
                } else if (
                    filter.minimum !== undefined &&
                    filter.maximum !== undefined
                ) {
                    const isDateType = metaDataDate.some(
                        (metadata) => metadata.name === filter.name,
                    );
                    if (!isDateType) {
                        allValues.push(filter.minimum.toFixed(1));
                        allValues.push(filter.maximum.toFixed(1));
                    }
                }
            });

            setSelectedFieldValue((prevFieldValue) => {
                const preparedFieldValue = Array.isArray(prevFieldValue)
                    ? prevFieldValue
                    : [];
                return [...new Set([...preparedFieldValue, ...allValues])];
            });

            setFilters((prevFilters) => {
                const preparedFilters = Array.isArray(prevFilters)
                    ? prevFilters
                    : [];
                const newFilters = [...preparedFilters, ...topFilters];
                const filterMap = new Map(
                    newFilters.map((filter) => [filter.name, filter]),
                );
                return Array.from(filterMap.values());
            });
        }
    }, [topFilters, metaDataDate, setFilters, setSelectedFieldName, setSelectedFieldValue, reset]);
};

export default useTopFiltersEffect;
